import React from 'react';
import { Footer } from '../Footer';
import { MenuLogo } from '../nav/Links';
import '../../assets/styles/sms.scss';

export const PublicLayout = (props) => {
  return (
    <>
      <div className='navbar-wrap navbar-sms'>
        <MenuLogo />
        <a href='https://www.exelot.com/he/contact/' className='support-number'>
          שירות לקוחות
        </a>
      </div>
      <main>{props.children}</main>
      <Footer />
    </>
  );
};
